import { CHUNK_TEMPLATE } from './manifest.const';
export function parseHlsManifests(mainManifest, subManifests) {
    const streamInfo = parseHlsMainManifest(mainManifest);
    const representations = { audio: [], video: [] };
    let totalDuration = 0;
    let totalChunks = 0;
    streamInfo.video.forEach(video => {
        if (!subManifests[video.uri]) {
            throw new Error(`Sub-manifest not found for video stream: ${video.uri}`);
        }
        const { representation, duration, chunks } = parseHlsSubManifest(subManifests[video.uri], video.bandwidth, video.videoCodecs, video.uri, video.resolution);
        if (totalDuration === 0) {
            totalDuration = duration;
        }
        if (totalChunks === 0) {
            totalChunks = chunks;
        }
        representations.video.push(representation);
    });
    const firstVideo = streamInfo.video[0];
    if (streamInfo.audio.uri && (firstVideo === null || firstVideo === void 0 ? void 0 : firstVideo.audioCodecs)) {
        const codecs = firstVideo.audioCodecs;
        const bandwidth = firstVideo.bandwidth;
        if (subManifests[streamInfo.audio.uri]) {
            const { representation } = parseHlsSubManifest(subManifests[streamInfo.audio.uri], bandwidth, codecs, streamInfo.audio.uri);
            representations.audio.push(representation);
        }
    }
    const videoCodecs = representations.video.length ? representations.video[0].codecs : '';
    const audioCodecs = representations.audio.length ? representations.audio[0].codecs : '';
    return {
        totalDuration,
        totalChunks,
        representations,
        codecs: {
            audio: audioCodecs,
            video: videoCodecs
        }
    };
}
export function parseHlsMainManifest(manifest) {
    const videoStreamInfo = [];
    const audioStreamInfo = { uri: '' };
    const lines = manifest.split('\n');
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.startsWith('#EXT-X-STREAM-INF:')) {
            const streamParams = parseStreamInfLine(line);
            const streamData = {
                bandwidth: 0,
                videoCodecs: '',
                audioCodecs: '',
                resolution: '',
                frameRate: 0,
                uri: ''
            };
            if (streamParams['BANDWIDTH']) {
                streamData.bandwidth = parseInt(streamParams['BANDWIDTH'], 10);
            }
            if (streamParams['CODECS']) {
                const codecs = streamParams['CODECS'].split(',');
                streamData.videoCodecs = codecs[0] || '';
                streamData.audioCodecs = codecs[1] || '';
            }
            if (streamParams['RESOLUTION']) {
                streamData.resolution = streamParams['RESOLUTION'];
            }
            if (streamParams['FRAME-RATE']) {
                streamData.frameRate = parseFloat(streamParams['FRAME-RATE']);
            }
            if (i + 1 < lines.length) {
                const uriLine = lines[i + 1].trim();
                if (!uriLine.startsWith('#')) {
                    streamData.uri = uriLine;
                    videoStreamInfo.push(streamData);
                }
            }
        }
        if (line.startsWith('#EXT-X-MEDIA:') && line.includes('TYPE=AUDIO')) {
            const uriMatch = line.match(/URI="([^"]+)"/);
            if (uriMatch) {
                audioStreamInfo.uri = uriMatch[1];
            }
        }
    }
    const video = videoStreamInfo.sort((a, b) => a.bandwidth - b.bandwidth);
    return {
        video,
        audio: audioStreamInfo
    };
}
function parseStreamInfLine(line) {
    const result = {};
    const content = line.substring('#EXT-X-STREAM-INF:'.length);
    // Regex that matches key=value pairs where value might be quoted
    const regex = /([^=,]+)=(?:"([^"]*)"|([^,]*))/g;
    let match;
    while ((match = regex.exec(content)) !== null) {
        const key = match[1];
        // If quoted value exists use it, otherwise use the unquoted one
        const value = match[2] !== undefined ? match[2] : match[3];
        result[key] = value;
    }
    return result;
}
export function parseHlsSubManifest(manifest, bandwidth, codecs, uri, resolution) {
    const lines = manifest.split('\n');
    let initUrl = '';
    const segments = [];
    let targetDuration = 0;
    let mediaSequence = 1;
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.startsWith('#EXT-X-TARGETDURATION:')) {
            targetDuration = parseInt(line.substring('#EXT-X-TARGETDURATION:'.length), 10);
        }
        else if (line.startsWith('#EXT-X-MEDIA-SEQUENCE:')) {
            mediaSequence = parseInt(line.substring('#EXT-X-MEDIA-SEQUENCE:'.length), 10);
        }
        else if (line.startsWith('#EXT-X-MAP:')) {
            // Extract initialization segment
            const mapLine = line.substring('#EXT-X-MAP:'.length);
            const uriMatch = mapLine.match(/URI="([^"]+)"/);
            if (uriMatch) {
                initUrl = uriMatch[1];
            }
        }
        else if (line.startsWith('#EXTINF:')) {
            // Extract segment duration and URL
            const durationStr = line.substring('#EXTINF:'.length, line.indexOf(','));
            const duration = parseFloat(durationStr);
            // The next line should contain the segment URL
            if (i + 1 < lines.length) {
                const urlLine = lines[i + 1].trim();
                if (!urlLine.startsWith('#')) {
                    segments.push({ duration, url: urlLine });
                }
            }
        }
    }
    const totalDuration = segments.reduce((sum, segment) => sum + segment.duration, 0);
    const totalChunks = segments.length;
    let name = `${Math.floor(bandwidth / 1000)} kbps`;
    if (resolution) {
        name = `${resolution}, ${name}`;
    }
    // video_mid_1.m4s => video_mid_$Number$.m4s to follow dash template parsing
    const chunkUrlTemplate = segments[0].url.replace(/\d+/, CHUNK_TEMPLATE);
    const representation = {
        id: uri.replace('.m3u8', ''),
        name,
        duration: targetDuration,
        chunkUrlTemplate,
        initUrl,
        bandwidth,
        startIndex: mediaSequence,
        codecs
    };
    return {
        representation,
        duration: totalDuration,
        chunks: totalChunks
    };
}
